import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SpeakerSocialLinks from '../components/SpeakerSocialLinks';
import { SPONSOR_FORM_URL } from '../config';
import '../styles/DavidSinclairPage.css';

function NiculinaPsihologPage() {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="speaker-hero">
        <video 
          className="speaker-hero-video"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        <div className="speaker-hero-overlay"></div>
        
        <div className="container">
          <div className="speaker-hero-content">
            <div className="speaker-hero-left">
              <h1 className="speaker-hero-name">
                NICULINA<br />GHEORGHIȚĂ
              </h1>
              <SpeakerSocialLinks speakerId="niculina-gheorghita" className="speaker-hero-socials" linkClassName="speaker-hero-social-icon" />
              <Link to="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse speaker-hero-btn">
                CUMPĂRĂ UN TICKET
              </Link>
            </div>
            
            <div className="speaker-hero-right">
              <img 
                src="/assets/niculina-gheorghita-transparent.png" 
                alt="Gheorghiță Niculina" 
                className="speaker-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who is Niculina */}
      <section className="sinclair-intro">
        <div className="container">
          <div className="sinclair-intro-grid">
            <div className="sinclair-intro-content">
              <div className="sinclair-badge">NICULINA GHEORGHIȚĂ</div>
              <h2 className="sinclair-intro-title">Cine este Niculina Gheorghiță?</h2>
              <p className="sinclair-intro-text">
                Niculina Gheorghiță este psiholog și unul dintre cei mai cunoscuți autori și traineri din România în zona de <strong>transformare personală</strong>.
              </p>
              <p className="sinclair-intro-text">
                Este apreciată pentru felul în care explică simplu <strong>mecanismele emoționale</strong> și oferă <strong>instrumente aplicabile</strong>.
              </p>
            </div>
            <div className="sinclair-intro-image">
              <img 
                src="/assets/niculina-psiholog.webp" 
                alt="Niculina Gheorghiță"
                className="sinclair-portrait"
              />
              {/* Floating Stats Cards */}
              <div className="floating-stats-cards">
                <div className="floating-stat-card">
                  <div className="floating-stat-number">20+</div>
                  <div className="floating-stat-label">ani practică</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">Autor</div>
                  <div className="floating-stat-label">Cărți transformare</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">Trainer</div>
                  <div className="floating-stat-label">Mii participanți</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Helps You */}
      <section className="sinclair-benefits-you">
        <div className="container">
          <div className="section-header-centered">
            <h2 className="section-title">Cu ce te ajută pe tine</h2>
            <p className="section-subtitle">Beneficii concrete din experiența Niculinei Gheorghiță</p>
          </div>

          <div className="benefits-you-list">
            <div className="benefit-you-item">
              <div className="benefit-you-number">01</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Înțelegi ce te blochează</h3>
                <p className="benefit-you-description">Vezi clar <strong>de unde vin fricile, tiparele și reacțiile automate</strong></p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">02</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Instrumente pentru viața reală</h3>
                <p className="benefit-you-description">Primești <strong>metode simple pentru reglare emoțională și claritate</strong></p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">03</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Schimbare din interior</h3>
                <p className="benefit-you-description">Înveți <strong>cum să modifici convingeri vechi</strong> care îți sabotează rezultatele</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">04</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Relații mai sănătoase</h3>
                <p className="benefit-you-description">Înțelegi <strong>dinamici de cuplu, limite, atașament și comunicare</strong></p>
              </div>
            </div>

            <div className="benefit-you-item featured">
              <div className="benefit-you-number">05</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Direcție și stabilitate</h3>
                <p className="benefit-you-description">Pleci cu <strong>o structură mentală mai clară</strong>, nu doar "motivație"</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse">Rezervă-ți locul acum</a>
            <p className="cta-subtitle">Locuri limitate • Brain Event 2026</p>
          </div>
        </div>
      </section>

      {/* What She Has Done */}
      <section className="sinclair-discoveries">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce a realizat</h2>
            <p className="section-subtitle">Contribuții și impact</p>
          </div>

          <div className="discoveries-grid">
            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="12" y="8" width="24" height="32" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <line x1="18" y1="16" x2="30" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <line x1="18" y1="22" x2="30" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <line x1="18" y1="28" x2="26" y2="28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="discovery-title">Cărți despre vindecare</h3>
              <p className="discovery-description">A scris numeroase cărți despre vindecare și transformare personală</p>
            </div>

            <div className="discovery-card featured">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="16" r="6" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="14" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="24" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="34" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <line x1="24" y1="22" x2="24" y2="28" stroke="currentColor" strokeWidth="2"/>
                  <line x1="24" y1="28" x2="14" y2="28" stroke="currentColor" strokeWidth="2"/>
                  <line x1="24" y1="28" x2="34" y2="28" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="discovery-title">Mii de participanți formați</h3>
              <p className="discovery-description">A format mii de participanți din România și diaspora prin cursuri și programe</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 8 L32 20 L28 20 L28 28 L36 28 L36 32 L28 32 L28 40 L20 40 L20 32 L12 32 L12 28 L20 28 L20 20 L16 20 L24 8Z" fill="currentColor" opacity="0.3"/>
                  <circle cx="24" cy="24" r="4" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Programe de autocunoaștere</h3>
              <p className="discovery-description">A creat programe de autocunoaștere, reglare emoțională și rescriere mentală</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="16" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M24 12 L24 24 L32 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="24" cy="24" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Prezență publică activă</h3>
              <p className="discovery-description">Este invitată frecvent la conferințe, podcasturi și evenimente din România</p>
            </div>
          </div>
        </div>
      </section>

      {/* Speakers Section */}
      <section className="benefits" id="speakeri">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Alți Speakeri de la Brain Event 2026</h2>
            <p className="section-subtitle">Experți de top din domeniul neuroștiinței și optimizării cognitive</p>
          </div>

          <div className="benefits-stories-grid">
            {/* David Sinclair */}
            <Link to="/david-sinclair" className="benefit-story-card" style={{backgroundImage: 'url(/david-sinclair-headshot-2024.png)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">David Sinclair</h3>
                <p className="story-description">Profesor Harvard • Expert în Longevitate</p>
                {/* <SpeakerSocialLinks speakerId="david-sinclair" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Diana Palotas */}
            <Link to="/diana-palotas" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/Diana-Palotas-card.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Diana Palotas</h3>
                <p className="story-description">CEO Neuros • Specialist în Neurotehnologie</p>
                {/* <SpeakerSocialLinks speakerId="diana-palotas" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Dr. Daniel Amen */}
            <Link to="/daniel-amen" className="benefit-story-card" style={{backgroundImage: 'url(/assets/amen-speaker.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Dr. Daniel Amen</h3>
                <p className="story-description">Medic în Sănătatea Creierului • Prezență Online</p>
                {/* <SpeakerSocialLinks speakerId="daniel-amen" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Matthew Walker - Featured */}
            <Link to="/matthew-walker" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/matthew-walker-speaker.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Matthew Walker</h3>
                <p className="story-description">Expert în Somnologie • Autor Bestseller</p>
              </div>
            </Link>

            {/* Specialist Neurofiziologie */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Specialist Neurofiziologie</h3>
                <p className="story-description">Standardele moderne ale neurofiziologiei</p>
              </div>
            </div>

            {/* Expert Neuromodulare */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Expert Neuromodulare</h3>
                <p className="story-description">Optimizarea recuperării sistemului nervos</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpara un ticket</a>
          </div>
        </div>
      </section>

      {/* Contact / Sponsor form — now on dedicated sponsorship app */}
      <section className="speaker-contact">
        <div className="container">
          <div className="speaker-contact-header">
            <h2 className="speaker-contact-title">Ai întrebări despre Niculina Gheorghiță sau Brain Event?</h2>
            <p className="speaker-contact-subtitle">
              Completează formularul de sponsorizare și echipa noastră te va contacta în cel mai scurt timp.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href={SPONSOR_FORM_URL} className="btn btn-primary btn-large">Aplică pentru Sponsorizare</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default NiculinaPsihologPage;

